interface BetaFeature {
  id: string;
  title: string;
  description: string;
  subtext?: string;
  icon?: React.ComponentType<any>;
}

export const betaFeaturesListings: BetaFeature[] = [];